import axios from "axios";

const ROOT = "/api/v1/conversion-reports";

async function request(config) {
	try {
		const response = await axios({ ...config, url: `${ROOT}${config.url}` });
		return response.data;
	} catch (error) {
		let data = error.response?.data;
		if (data instanceof ArrayBuffer) {
			try {
				data = JSON.parse(new TextDecoder().decode(data));
			} catch {
				data = null;
			}
		}
		throw new Error(data?.message || error.message || "Unable to load conversion reports");
	}
}

export default {
	getAccess: () => request({ url: "/access" }),
	listAccess: () => request({ url: "/access-list" }),
	grantAccess: (email) => request({ method: "post", url: "/access-list", data: { email } }),
	revokeAccess: (email) =>
		request({ method: "delete", url: `/access-list/${encodeURIComponent(email)}` }),
	export: (filters) => request({ url: "/export", params: filters, responseType: "arraybuffer" }),
};
